import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import { detectLanguageFromPath } from '../utils/languageUtils';

// Detect language directly from the URL path - no LanguageDetector needed
const detectedLng = detectLanguageFromPath(window.location.pathname);

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: detectedLng,
    fallbackLng: 'sk',
    supportedLngs: ['sk', 'en', 'pl', 'cs'],
    defaultNS: 'common',
    ns: ['common', 'homepage', 'services', 'forms', 'blog', 'tos', 'privacy', 'seo', 'market-entry'],

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: true,
    },

    debug: process.env.NODE_ENV === 'development',
  });

export default i18n;
